// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RCKI","selected":"styles_selected__35PI9"};